class CollectionFilters {
  constructor() {
    this.form = document.getElementById('CollectionFiltersForm');
    this.gridContainer = document.getElementById('ProductGridContainer');
    
    if (!this.form || !this.gridContainer) return;
    
    this.bindEvents();
  }

  bindEvents() {
    this.form.addEventListener('input', this.debouncedSubmit.bind(this));
    this.form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.onSubmit();
    });

    // Pagination/Load More
    document.addEventListener('click', (e) => {
      if (e.target.matches('[data-load-more]')) {
        e.preventDefault();
        this.loadMore(e.target);
      }
    });
  }

  debouncedSubmit() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => {
      this.onSubmit();
    }, 500);
  }

  async onSubmit() {
    this.gridContainer.classList.add('is-loading');
    const formData = new FormData(this.form);
    const searchParams = new URLSearchParams(formData).toString();
    const url = `${window.location.pathname}?${searchParams}`;

    try {
      const response = await fetch(url);
      const text = await response.text();
      this.renderPage(text, url);
    } catch (error) {
      console.error('Error fetching filtered collection', error);
    } finally {
      this.gridContainer.classList.remove('is-loading');
    }
  }

  async loadMore(btn) {
    const url = btn.href;
    btn.innerHTML = '<span class="loading-spinner"></span>';
    btn.style.pointerEvents = 'none';

    try {
      const response = await fetch(url);
      const text = await response.text();
      
      const html = new DOMParser().parseFromString(text, 'text/html');
      const newItems = html.querySelectorAll('.product-grid__item');
      const grid = this.gridContainer.querySelector('.product-grid');
      
      newItems.forEach(item => {
        grid.appendChild(item);
      });

      // Replace pagination wrapper
      const newPagination = html.querySelector('.collection-pagination');
      const currentPagination = this.gridContainer.querySelector('.collection-pagination');
      if (currentPagination && newPagination) {
        currentPagination.innerHTML = newPagination.innerHTML;
      } else if (currentPagination) {
        currentPagination.innerHTML = '';
      }

    } catch (error) {
      console.error('Error loading more items', error);
      btn.innerHTML = 'Load More';
      btn.style.pointerEvents = 'auto';
    }
  }

  renderPage(text, url) {
    const html = new DOMParser().parseFromString(text, 'text/html');
    const newGridContainer = html.getElementById('ProductGridContainer');
    
    if (newGridContainer) {
      this.gridContainer.innerHTML = newGridContainer.innerHTML;
    }
    
    // Update URL
    window.history.pushState({ path: url }, '', url);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new CollectionFilters();
});
